import React from 'react'
import PropTypes from 'prop-types'

import {
  analyticsAttrFormatter,
  getLinkUrl,
  isBannerTypeOf,
} from '../../utility'

import { Link2 } from './link.jsx'

export const LinkList = ({
  linkList,
  className,
  buttonClass,
  buttonColor,
  spacingClass,
  bannerType,
}) => {
  const isProductBanner = isBannerTypeOf(bannerType, 'product')

  return (
    <>
      {linkList &&
        linkList.map((link, index) => (
          <React.Fragment key={index}>
            {link?.text && (
              <div
                key={index}
                className={`u-flex ${
                  !isProductBanner ? 'u-marginTop2gu' : ''
                } ${
                  spacingClass && index > 0 && !isProductBanner
                    ? spacingClass
                    : ''
                } ${className || ''}`}
              >
                <Link2
                  url={getLinkUrl(link)}
                  text={link.text}
                  icon={link.icon}
                  iconColor={buttonColor}
                  className={`Button ${
                    !isProductBanner
                      ? 'Button--secondary'
                      : linkList.length - 1 === index
                        ? 'u-paddingVert4gu'
                        : 'u-paddingTop4gu'
                  } u-textUppercase u-textNoWrap u-paddingLeft4gu u-paddingRight4gu ${
                    buttonClass || ''
                  }`}
                  {...analyticsAttrFormatter(link.description)}
                />
              </div>
            )}
          </React.Fragment>
        ))}
    </>
  )
}

LinkList.propTypes = {
  linkList: PropTypes.array.isRequired,
  className: PropTypes.object,
  buttonClass: PropTypes.string,
  buttonColor: PropTypes.string,
  spacingClass: PropTypes.string,
  bannerType: PropTypes.string,
}
